import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";

@Component({
  standalone: false,
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit  {
  @Input()
  tabs: { label: string, id: number, isActive: boolean }[];
  @Output()
  tabSelected = new EventEmitter<{ label: string, id: number }>()
  activeId: number = null;
  constructor() {

  }

  ngOnInit() {

  }

  tabSelectHandler(selectedTab) {
    this.activeId = selectedTab.id;
    this.tabSelected.emit(selectedTab);
  }
}
